import ApiConfig from "../Config";
import apiService from "../services/apiService";

const productService = {
  getAllProducts: () => apiService.get(ApiConfig.getAllProducts),

  getSponsoreProducts: () => apiService.get(ApiConfig.getSponsorProducts),

  addSponsoreProduct: (data) =>
    apiService.post(ApiConfig.addSponserProduct, {
      data,
    }),

  getTopProducts: () => apiService.get(ApiConfig.getTopProducts),

  setTopProducts: (productIds, token) =>
    apiService.post(
      ApiConfig.setTopProducts,
      { productIds },
      {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      },
    ),

  editProduct: (data) =>
    apiService.post(ApiConfig.editProduct, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
};
export default productService;
